<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAppleLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M19.264 16.428a9.8 9.8 0 0 1-.968 1.74q-.764 1.087-1.247 1.506-.745.686-1.602.706-.615 0-1.48-.354-.866-.352-1.593-.352-.763 0-1.638.352-.877.355-1.416.372-.822.036-1.638-.724-.522-.455-1.304-1.56-.84-1.18-1.38-2.739-.578-1.684-.578-3.264 0-1.81.783-3.118.615-1.05 1.64-1.659a4.4 4.4 0 0 1 2.215-.625q.652 0 1.715.399 1.06.399 1.36.4.223 0 1.507-.471 1.211-.436 2.05-.364 2.272.183 3.408 1.795-2.031 1.232-2.01 3.444.018 1.724 1.247 2.863.556.528 1.247.818-.15.435-.318.834M15.79 2.76q-.001 1.35-.985 2.519c-.79.925-1.748 1.46-2.785 1.375A3 3 0 0 1 12 6.313c0-.865.376-1.79 1.044-2.546a4 4 0 0 1 1.272-.955q.771-.375 1.456-.412.02.18.019.36"
    />
</svg>
